import { Button, Col, Form, Row, Section, message } from 'ui';
import { NewPasswordFormContent, type NewPasswordFormContentValues, useGetErrorMessage } from 'features/settings';
import { useResetPasswordMutation } from '../../queries';

type P = {
  onNavigateToPrimaryLogin: () => void;
  onSuccessChangePassword: () => void;
  token?: string;
};

const NewPasswordForm = ({ onNavigateToPrimaryLogin, onSuccessChangePassword, token }: P) => {
  const getErrorMessage = useGetErrorMessage();

  const { isPending: isLoading, mutate: changePassword } = useResetPasswordMutation();

  const onFinish = (data: NewPasswordFormContentValues) => {
    changePassword(
      { ...data, resetPasswordToken: token },
      {
        onError(error) {
          const { duration, errorMessage } = getErrorMessage(error);
          message.error(errorMessage, { duration });
        },
        onSuccess() {
          message.success('Your password was successfully changed');
          onSuccessChangePassword();
        },
      },
    );
  };

  return (
    <Form<NewPasswordFormContentValues> className="login-form" onFinish={onFinish}>
      <NewPasswordFormContent<NewPasswordFormContentValues> />

      <Section lineBottom={false} lineTop={false} paddingBottom={false} paddingTop>
        <Row gutter={[0, 'ms']}>
          <Col span={24}>
            <Button block htmlType="submit" loading={isLoading} type="primary">
              Reset password
            </Button>
          </Col>
          <Col span={24}>
            <Button
              block
              onClick={() => {
                onNavigateToPrimaryLogin();
              }}
            >
              Back to Log in
            </Button>
          </Col>
        </Row>
      </Section>
    </Form>
  );
};

export default NewPasswordForm;
